export const WEBSOCKETSTATUS = "WEBSOCKETSTATUS";
export const NETWORK = "NETWORK"
export const WEBSOCKETCONNECTION = "WEBSOCKETCONNECTION";
